
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 37.999L13.245 40l2.216-2.216-4.19-4.19L7 38zm7.788-15a2.287 2.287 0 00-.674 2.38l.815 2.677-3.183 3.184 6.015 6.014 3.178-3.178 2.672.817c.858.263 1.79 0 2.384-.674l2.222-2.602-10.834-10.834-2.595 2.215zm25.207-10.045l-3.95-3.95a3.43 3.43 0 00-4.695-.146L18.91 19.48l10.61 10.611L40.142 17.65a3.43 3.43 0 00-.147-4.696z","fill":"#535353"}})])
          )
        }
      }
    